module.exports = __webpack_public_path__ + "img/4.b12862f1.png";